import * as React from 'react'
import { styled } from 'next-yak'

import * as colors from '../../../../constants/colors'
import { lightweight, standalone, type SymbolProps } from '../../../spritesheetUtils'
import * as illustration from '../../Illustration'

const ID = 'chatgpt-illustration-icon'

export function ChatGPTSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 90 80">
      <g>
        <path
          d="M85.2 71.5V21.3s1-14.7-10.3-19.4C72.6.9 70.1.5 67.6.5L33.3.3S21.6-.3 16.5 8.7c-1.7 3-2.5 6.3-2.5 9.7v36.3s-1 16.7 15.4 16.7c15 .1 55.8.1 55.8.1z"
          fill="currentColor"
        />
        <path
          d="M68.5 48.4v.9c0 .7-.1 1.4-.2 2.1-.3 1.5-.9 2.8-1.6 4.1-1.9 3.2-4.7 5.3-8.3 6.2-.2 0-.3.1-.5.1v.1c0 .1-.1.2-.1.2-1 2.7-2.6 4.8-4.9 6.5-2 1.4-4.2 2.2-6.6 2.5h-2.6c-.5 0-1-.1-1.5-.2-2.8-.6-5.1-1.9-7-4-.1-.1-.1-.1-.1-.2-3.2.6-6.3.2-9.2-1.3-2.9-1.5-5-3.9-6.2-6.9-1.2-3-1.3-6.1-.3-9.2-.1-.1-.1-.2-.2-.3-1.3-1.5-2.3-3.3-2.8-5.3-.2-.8-.4-1.7-.4-2.6v-1.9c0-.3.1-.7.1-1 .2-1.2.5-2.4 1-3.5 1.4-3.2 3.7-5.6 7-7 .8-.4 1.6-.6 2.5-.8.1 0 .2-.1.2-.2v-.1c1.2-3.3 3.3-5.8 6.4-7.5 1.3-.7 2.8-1.2 4.3-1.4.5-.1 1.1-.1 1.6-.2H40.3c.8 0 1.6.1 2.4.3 2.7.6 4.9 2 6.8 4l.1.1h.2c.6-.1 1.1-.2 1.7-.2h2.1c.9.1 1.8.3 2.6.5 5.7 1.7 9.1 6.6 9.6 11.4.1.9.1 1.8 0 2.8-.1.9-.3 1.8-.5 2.7V39.4l.1.1c.9 1.1 1.7 2.2 2.2 3.5.6 1.5 1 3 1 4.7-.1.4-.1.6-.1.7zM25.9 30.8c-.1 0-.2.1-.3.1-3.4 1.4-5.9 4.5-6.3 8.3-.1 1-.1 1.9.1 2.9.4 1.8 1.1 3.4 2.4 4.8.7.8 1.6 1.5 2.5 2 1.1.6 2.2 1.3 3.3 1.9 2.2 1.3 4.5 2.6 6.7 3.9.1 0 .2.1.3.1 1.5-.9 3-1.7 4.5-2.6v-.1c-.1-.1-.2-.1-.3-.2l-12-6.9c-.1-.1-.2-.1-.3-.2-.5-.3-.7-.8-.7-1.4V31c.1.1.1 0 .1-.2zm19.9-7.3-.2-.2c-.8-.6-1.6-1.1-2.5-1.4-.9-.3-1.8-.6-2.7-.7-.5 0-1-.1-1.5-.1s-1.1.1-1.6.2c-2.9.7-5.2 2.3-6.7 4.9-.9 1.5-1.3 3.2-1.3 5v11.6c0 .3 0 .2.2.4.8.5 1.7 1 2.5 1.4.5.3 1.1.6 1.6.9.1 0 .1.1.2.1V31.3c0-.2 0-.3.1-.5.1-.5.4-.8.9-1.1 3.5-2 7-4 10.5-6.1.2.1.3 0 .5-.1zm-7.2 41.8.2.2c1.9 1.5 4.1 2.1 6.6 2.1.6 0 1.1-.1 1.7-.2 3.2-.7 5.8-2.9 7.1-5.9.5-1.2.8-2.5.8-3.8v-12c-1.5-.9-3-1.7-4.5-2.6h-.1V57.5c0 .6-.3 1.1-.8 1.5-.1 0-.1.1-.2.1-3.5 2-7 4-10.5 6.1-.1 0-.2.1-.3.1zM58.5 58c.1 0 .2-.1.3-.1 1.1-.4 2-1 2.9-1.8.8-.8 1.5-1.6 2.1-2.6 1-2 1.4-4 1.1-6.2-.2-1.4-.7-2.7-1.4-3.9-.9-1.5-2.1-2.6-3.6-3.5-.6-.4-1.3-.7-1.9-1.1-2.7-1.6-5.4-3.1-8.1-4.7-.1-.1-.2-.1-.3-.1-1.5.9-3 1.7-4.5 2.6l-.1.1c.1.1.2.1.3.2l12 6.9c.1.1.2.1.3.2.4.3.7.6.8 1.1v13c.1-.2.1-.2.1-.1zm3.6-20.9c0-.1 0-.2.1-.3.2-1.1.1-2.1-.1-3.2-.4-2.1-1.3-3.9-2.9-5.4-2.2-2.2-5.3-3.2-8.4-2.7-1.3.2-2.5.6-3.6 1.2-3.4 1.9-6.7 3.9-10.1 5.8-.1 0-.1.1-.2.1v5.3c.1 0 .2-.1.3-.2l12-6.9c.1-.1.2-.1.3-.1.3-.2.7-.2 1.1-.2.3 0 .5.1.7.3 1.3.7 2.5 1.5 3.8 2.2 2.2 1.3 4.4 2.6 6.6 3.8.1.1.3.2.4.3zM47.4 50.9c-.1.1-.2.1-.3.2l-12 6.9c-.1.1-.2.1-.3.2-.3.2-.7.2-1.1.2-.3 0-.5-.1-.7-.3-3-1.7-6-3.5-9-5.2-.6-.3-1.1-.6-1.7-1-.1 0-.1-.1-.2-.1-.1.3-.1.7-.1 1 0 .7 0 1.4.1 2.1.2 1.3.7 2.6 1.4 3.8.8 1.3 1.8 2.3 3.1 3.2 1.4.9 2.9 1.4 4.6 1.6 1 .1 1.9 0 2.9-.1 1.1-.2 2.2-.6 3.2-1.2 1.1-.7 2.3-1.3 3.4-2 2.2-1.3 4.4-2.5 6.5-3.8.1-.1.2-.1.3-.2-.1-1.8-.1-3.5-.1-5.3zm0-3.5v-6s-.1 0-.1-.1c-1.7-1-3.4-1.9-5.1-2.9-1.7 1-3.4 2-5.1 2.9 0 0-.1 0-.1.1v6c1.7 1 3.4 2 5.1 2.9 0 0 .1 0 .1.1 1.7-.9 3.5-2 5.2-3z"
          strokeWidth={0}
          fill={colors.PRIMARY_GREY_900}
        />
        <path
          d="M77.3 79.8H21.5c-5.1 0-9.1-1.5-12-4.6C4.6 70 5 62.2 5 61.9V26.7c0-3.7.9-7.2 2.7-10.2 5.4-9.5 17.3-9 17.8-9l33.1.2c2.8 0 5.4.5 7.7 1.4 11.7 4.8 11.1 19.1 11 20.3v50.4zM25.1 10.6c-1.8 0-10.6.4-14.7 7.4-1.5 2.6-2.2 5.6-2.2 8.7V62c0 .2-.3 6.8 3.7 11 2.3 2.4 5.5 3.6 9.7 3.6h52.6V29.3c0-.1.8-13.2-9-17.3-1.9-.8-4.1-1.2-6.5-1.2l-33.2-.2h-.4z"
          strokeWidth={0}
          fill={colors.PRIMARY_GREY_900}
        />
      </g>
    </symbol>
  )
}

const ChatGPTStandaloneContent = standalone(ChatGPTSymbol, ID)

export const ChatGPT = styled(function ChatGPTeStandaloneComponent(props: illustration.SpecificIllustrationProps) {
  return (
    <illustration.Illustration {...props} name="chatgpt">
      <ChatGPTStandaloneContent />
    </illustration.Illustration>
  )
})`
  fill: none;
`

export const ChatGPTLightweight = styled(function ChatGPTComponent(props: illustration.SpecificIllustrationProps) {
  return (
    <illustration.Illustration {...props} name="chatgpt">
      {lightweight(ID)}
    </illustration.Illustration>
  )
})`
  fill: none;
`
